import { jsx, jsxs } from 'react/jsx-runtime';
import { styled } from 'styled-components';
"use strict";
function HeaderShadow({
  leftColumnWidth,
  shadowLeftColumn,
  show
}) {
  const height = 15;
  return /* @__PURE__ */jsx(HeaderShadowWrapper, {
    $height: height,
    $show: show,
    children: /* @__PURE__ */jsxs(HeaderShadowGrid, {
      $templateColumns: shadowLeftColumn ? `0px 1fr` : `${leftColumnWidth}px 1fr`,
      children: [/* @__PURE__ */jsx("div", {}), /* @__PURE__ */jsx(HeaderShadowDrop, {})]
    })
  });
}
const HeaderShadowDrop = styled.div`
  background: linear-gradient(to bottom, rgb(23 49 73 / 0.1), transparent);
`;
const HeaderShadowWrapper = styled.div`
  width: 100%;
  height: ${({
  $height
}) => $height}px;
  margin-bottom: ${({
  $height
}) => -$height}px;
  z-index: 2;
  position: relative;
  opacity: ${({
  $show
}) => $show ? 1 : 0};
  transition: opacity 0.2s;
  overflow-x: hidden;
`;
const HeaderShadowGrid = styled.div`
  display: grid;
  grid-template-columns: ${({
  $templateColumns
}) => $templateColumns};
  height: 100%;
`;
export { HeaderShadow };
//# sourceMappingURL=HeaderShadow.mjs.map
